@if (announcements && announcements.length > 0) {
  <section
    id="announcements"
    class="w-100 redesigned-announcement">
    @for (a of announcements; track a.announcementId; let i = $index) {
      <button
        id="announcement{{i}}"
        [class.announcementBannerRedesigned]="!useHighlightsPortalIcon"
        class="w-100 btn btn-xl btn-tertiary announcementBanner"
        (click)="open(a)">
        <ng-container [ngTemplateOutlet]="withTeaser" [ngTemplateOutletContext]="{ announcement: a }"></ng-container>
      </button>
    }
  </section>
}

<ng-template #withTeaser let-a="announcement">
  <div class="d-flex justify-content-start align-items-center announcementTeaserContainer">
    @if (useHighlightsPortalIcon) {
      <i
        class="fa {{ announcementIconClass }} announcementBannerText announcementBannerIcon"
        aria-hidden="true">
      </i>
    } @else {
      <zbp-icon [iconName]="zbpIconNames.info_circle" iconSize="font-size" class="ms-2 redesigned-info-circle">
      </zbp-icon>
    }
    <div class="announcement-content">
      <div class="fw-bold announcementBannerText announcementBannerTitle">{{ a.title }}</div>
      <small class="announcementBannerText announcementBannerTeaser" [innerHTML]="renderTeaser(a.message)"></small>
      <zbp-icon
        [iconName]="zbpIconNames.arrow_right"
        class="redesigned-arrow-right"
        >
      </zbp-icon>

    </div>
  </div>
</ng-template>
